import { Box, styled } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  width    : '100%',
  height   : '100%',
  position : 'absolute',
  zIndex   : -1,
}));

export const Logo = styled('img')({
  margin    : '20px',
  maxWidth  : '156px',
  maxHeight : '61px',
});

export const Graphic1 = styled('img')({
  width    : '40%',
  maxWidth : '600px',
});

export const Graphic2 = styled('img')({
  width     : '30%',
  maxWidth  : '400px',
  transform : 'translate(0, 40%)',
});
